import { trackRemoveFromCart } from '@jbhi-fi/utils/src/ga4Tracking';
import { transformCartItemForMessages, transformCartItemForTracking } from './transformCartItemForTracking';
import { getStoreCurrency } from '../shopify/getStoreCurrency';
import { JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';

export const trackRemoveFromCartShopify = async (removedItem: JbCartItem | undefined, changedQuantity?: number) => {
  if (!removedItem) return;
  trackRemoveFromCart({
    currency: getStoreCurrency(),
    removedItem: transformCartItemForTracking({
      ...removedItem,
      ...(changedQuantity ? { quantity: changedQuantity } : {}),
    }),
    message: transformCartItemForMessages(removedItem),
  });
};
